<template lang="pug">
  .module__main
    .module__title Настройка внутребанковских переводов
    .module-content__container(v-loading="isLoading")
      .bank-add__btn
        el-button(@click="openBankActivate('sbp')" type="primary") Активировать внутребанк
        el-button(@click="openBankActivate('qr')" type="primary") Активировать QR внутребанк
      .banks__container.mt10(v-if="showEnabledBanks")
        .banks-container__title Активные банки (СБП+карты)
        .banks__list
          .bank__container(v-for="bank in enabledInterBanks" :key="`enabled-bank-sbp-${bank.id}`")
            .title.mb5 {{ bank.name }}
            .amount
              .amount__title Сумма от:
              .amount__edit(v-if="editedBank.interbank_type === 'sbp' && editedBank.id === bank.id")
                el-input(size="mini" v-model="editedBank.min_amount" :min="1" type="number")
                .flex-centered.ml5
                  el-button(circle size="mini" :disabled="bankIsEditing" icon="el-icon-check" type="success" @click="startEnableInterBank('edit', 'sbp')")
                  el-button(circle size="mini" :disabled="bankIsEditing" icon="el-icon-close" type="danger" @click="resetEditBank")
              .amount__value(v-else)
                span.mr5(:class="bank.traffic_spill_enabled ? '' : 'color-success'") {{ bank.min_amount }}
                el-button(circle size="mini" icon="el-icon-edit" :disabled="bankIsEditing" type="primary" @click="activateEditBank(bank.id, bank.min_amount, 'sbp')")
            .amount
              .amount__title Пролив:
              .amount__edit(v-if="editedTrafficSpill.interbank_type === 'sbp' && editedTrafficSpill.id === bank.id")
                el-input(size="mini" v-model="editedTrafficSpill.traffic_spill_amount" :min="1" type="number")
                .flex-centered.ml5
                  el-button(circle size="mini" :disabled="bankIsEditing" icon="el-icon-check" type="success" @click="startEditTrafficSpillAmount")
                  el-button(circle size="mini" :disabled="bankIsEditing" icon="el-icon-close" type="danger" @click="resetEditTrafficSpill")
              .amount__value(v-else)
                span.mr5(:class="bank.traffic_spill_enabled ? 'color-success' : ''") {{ bank.traffic_spill_amount }}
                el-button(circle size="mini" icon="el-icon-edit" :disabled="bankIsEditing" type="primary" @click="activateEditTrafficSpill(bank.id, bank.traffic_spill_amount, 'sbp')")
            .amount
              .amount__title Процент обработки:
              .amount__edit(v-if="editedRatePercent.interbank_type === 'sbp' && editedRatePercent.id === bank.id")
                el-input(size="mini" v-model="editedRatePercent.rate_percent" :min="0" type="number")
                .flex-centered.ml5
                  el-button(circle size="mini" :disabled="bankIsEditing" icon="el-icon-check" type="success" @click="startEditRatePercent")
                  el-button(circle size="mini" :disabled="bankIsEditing" icon="el-icon-close" type="danger" @click="resetEditRatePercent")
              .amount__value(v-else)
                div
                  span.mr5 {{ bank.rate_percent }}
                  el-button(circle size="mini" icon="el-icon-edit" :disabled="bankIsEditing" type="primary" @click="activateEditRatePercent(bank.id, bank.rate_percent, 'sbp')")
            .amount
              .amount__title Текущий курс:
              .amount__value
                span {{ bank.rate }}
            .traffic_spill__btn.mt10
              el-button(v-if="bank.traffic_spill_enabled" size="mini" type="warning" @click="startDisableTrafficSpill(bank.id, 'sbp')") Отключить пролив
              el-tooltip(v-else content="Необходима сумма пролива" :disabled="!!bank.traffic_spill_amount" placement="top" )
                el-button(size="mini" :disabled="!bank.traffic_spill_amount" type="success" @click="startEnableTrafficSpill(bank.id, 'sbp')") Включить пролив
            .disable__btn.mt5
              el-button(type="danger" :disabled="bankIsEditing" size="mini" @click="startDisableInterBank(bank.id, bank.name, 'sbp')") Деактивировать внутрибанк
      .banks__container.mt10(v-if="showEnabledQrBanks")
        .banks-container__title Активные банки (QR)
        .banks__list
          .bank__container(v-for="bank in enabledQrInterBanks" :key="`enabled-bank-qr-${bank.id}`")
            .title.mb5 {{ bank.name }}
            .amount
              .amount__title Сумма от:
              .amount__edit(v-if="editedBank.interbank_type === 'qr' && editedBank.id === bank.id")
                el-input(size="mini" v-model="editedBank.min_amount" :min="1" type="number")
                .flex-centered.ml5
                  el-button(circle size="mini" :disabled="bankIsEditing" icon="el-icon-check" type="success" @click="startEnableInterBank('edit', 'qr')")
                  el-button(circle size="mini" :disabled="bankIsEditing" icon="el-icon-close" type="danger" @click="resetEditBank")
              .amount__value(v-else)
                span.mr5(:class="bank.traffic_spill_enabled ? '' : 'color-success'") {{ bank.min_amount }}
                el-button(circle size="mini" icon="el-icon-edit" :disabled="bankIsEditing" type="primary" @click="activateEditBank(bank.id, bank.min_amount, 'qr')")
            .amount
              .amount__title Пролив:
              .amount__edit(v-if="editedTrafficSpill.interbank_type === 'qr' && editedTrafficSpill.id === bank.id")
                el-input(size="mini" v-model="editedTrafficSpill.traffic_spill_amount" :min="1" type="number")
                .flex-centered.ml5
                  el-button(circle size="mini" :disabled="bankIsEditing" icon="el-icon-check" type="success" @click="startEditTrafficSpillAmount")
                  el-button(circle size="mini" :disabled="bankIsEditing" icon="el-icon-close" type="danger" @click="resetEditTrafficSpill")
              .amount__value(v-else)
                span.mr5(:class="bank.traffic_spill_enabled ? 'color-success' : ''") {{ bank.traffic_spill_amount }}
                el-button(circle size="mini" icon="el-icon-edit" :disabled="bankIsEditing" type="primary" @click="activateEditTrafficSpill(bank.id, bank.traffic_spill_amount, 'qr')")
            .amount
              .amount__title Процент обработки:
              .amount__edit(v-if="editedRatePercent.interbank_type === 'qr' && editedRatePercent.id === bank.id")
                el-input(size="mini" v-model="editedRatePercent.rate_percent" :min="0" type="number")
                .flex-centered.ml5
                  el-button(circle size="mini" :disabled="bankIsEditing" icon="el-icon-check" type="success" @click="startEditRatePercent")
                  el-button(circle size="mini" :disabled="bankIsEditing" icon="el-icon-close" type="danger" @click="resetEditRatePercent")
              .amount__value(v-else)
                div
                  span.mr5 {{ bank.rate_percent }}
                  el-button(circle size="mini" icon="el-icon-edit" :disabled="bankIsEditing" type="primary" @click="activateEditRatePercent(bank.id, bank.rate_percent, 'qr')")
            .amount
              .amount__title Текущий курс:
              .amount__value
                span {{ bank.rate }}
            .traffic_spill__btn.mt10
              el-button(v-if="bank.traffic_spill_enabled" size="mini" type="warning" @click="startDisableTrafficSpill(bank.id, 'qr')") Отключить пролив
              el-tooltip(v-else content="Необходима сумма пролива" :disabled="!!bank.traffic_spill_amount" placement="top" )
                el-button(size="mini" :disabled="!bank.traffic_spill_amount" type="success" @click="startEnableTrafficSpill(bank.id, 'qr')") Включить пролив
            .disable__btn.mt5
              el-button(type="danger" :disabled="bankIsEditing" size="mini" @click="startDisableInterBank(bank.id, bank.name, 'qr')") Деактивировать внутрибанк
    el-dialog(
      :visible.sync="bankToActivateActive"
      :before-close="resetBankActivate"
      :title="activateBankTitle"
      width="30%"
    )
      .dialog__container
        .dialog-input__block
          .title Банка
          el-select(v-model="bankToActivate.id" filterable placeholder="Банк")
            el-option(v-for="bank in activateDisabledBanks" :label="bank.name" :value="bank.id" :key="`activate-bank-${bank.id}`")
        .dialog-input__block
          .title Минимальная сумма заявки
          el-input(type="number" v-model="bankToActivate.min_amount" :min="1" placeholder="Сумма")
        .dialog__buttons
          el-button(type="success" :disabled="!canEnableInterBank" @click="startEnableInterBank('new')") Сохранить
          el-button(type="danger" @click="resetBankActivate") Отменить
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import {
  DISABLE_INTERBANK, DISABLE_TRAFFIC_SPILL,
  EDIT_INTERBANK_RATE_PERCENT, EDIT_TRAFFIC_SPILL_AMOUNT, ENABLE_INTERBANK, ENABLE_TRAFFIC_SPILL,
  LOAD_INTERBANKS, LOAD_QR_INTERBANKS
} from '../../store/const/exchange';
import instruments from '../../mixins/instruments';

export default {
  name: 'InterBanks',
  mixins: [
    instruments,
  ],
  data() {
    return {
      bankToActivateActive: false,
      bankToActivate: {
        interbank_type: '',
        id: null,
        min_amount: 1,
        rate_percent: 0,
      },
      editedBank: {
        interbank_type: '',
        id: null,
        min_amount: 0,
      },
      editedTrafficSpill: {
        interbank_type: '',
        id: null,
        traffic_spill_amount: 0,
      },
      editedRatePercent: {
        interbank_type: '',
        id: null,
        rate_percent: 0,
      },
    };
  },
  async mounted() {
    await this.loadBanks();
  },
  computed: {
    ...mapGetters([
      'loading',
      'error',
    ]),
    ...mapGetters('exchange', ['enabledInterBanks', 'disabledInterBanks', 'enabledQrInterBanks', 'disabledQrInterBanks']),
    isLoading() {
      return this.loading(LOAD_INTERBANKS) === 'loading' || this.loading(LOAD_QR_INTERBANKS) === 'loading';
    },
    canEnableInterBank() {
      return !!this.bankToActivate.id && !!this.bankToActivate.min_amount;
    },
    bankIsEditing() {
      return this.loading(ENABLE_INTERBANK) === 'loading' || this.loading(DISABLE_INTERBANK) === 'loading';
    },
    showEnabledBanks() {
      return this.enabledInterBanks.length > 0;
    },
    showEnabledQrBanks() {
      return this.enabledQrInterBanks.length > 0;
    },
    activateBankTitle() {
      return this.bankToActivate.interbank_type === 'sbp' ? 'Активация банка' : 'Активация QR банка';
    },
    activateDisabledBanks() {
      return this.bankToActivate.interbank_type === 'sbp' ? this.disabledInterBanks : this.disabledQrInterBanks;
    }
  },
  methods: {
    ...mapActions('exchange', {
      loadInterBanks: LOAD_INTERBANKS,
      loadQrInterBanks: LOAD_QR_INTERBANKS,
      enableInterBank: ENABLE_INTERBANK,
      disableInterBank: DISABLE_INTERBANK,
      editTrafficSpillAmount: EDIT_TRAFFIC_SPILL_AMOUNT,
      editInterbankRatePercent: EDIT_INTERBANK_RATE_PERCENT,
      enableTrafficSpill: ENABLE_TRAFFIC_SPILL,
      disableTrafficSpill: DISABLE_TRAFFIC_SPILL,
    }),
    async loadBanks() {
      await this.loadInterBanks();
      await this.loadQrInterBanks();
    },
    openBankActivate(interbank_type) {
      this.bankToActivate.interbank_type = interbank_type;
      this.bankToActivateActive = true;
    },
    resetBankActivate() {
      this.bankToActivateActive = false;
      this.bankToActivate.id = null;
      this.bankToActivate.min_amount = 1;
      this.bankToActivate.interbank_type = '';
    },
    activateEditBank(id, min_amount, interbank_type) {
      this.editedBank.interbank_type = interbank_type;
      this.editedBank.min_amount = min_amount;
      this.editedBank.id = id;
    },
    resetEditBank() {
      this.editedBank.id = null;
      this.editedBank.min_amount = 0;
      this.editedBank.interbank_type = '';
    },
    activateEditTrafficSpill(id, traffic_spill_amount, interbank_type) {
      this.editedTrafficSpill.interbank_type = interbank_type;
      this.editedTrafficSpill.traffic_spill_amount = traffic_spill_amount;
      this.editedTrafficSpill.id = id;
    },
    resetEditTrafficSpill() {
      this.editedTrafficSpill.id = null;
      this.editedTrafficSpill.traffic_spill_amount = 0;
      this.editedTrafficSpill.interbank_type = '';
    },
    activateEditRatePercent(id, rate_percent, interbank_type) {
      this.editedRatePercent.interbank_type = interbank_type;
      this.editedRatePercent.rate_percent = rate_percent;
      this.editedRatePercent.id = id;
    },
    resetEditRatePercent() {
      this.editedRatePercent.id = null;
      this.editedRatePercent.rate_percent = 0;
      this.editedRatePercent.interbank_type = '';
    },
    async startEnableInterBank(mode) {
      const bank = mode === 'edit' ? this.editedBank : this.bankToActivate;
      const confirmTitle = mode === 'edit' ? 'Вы уверены, что хотите изменить внутребанк?' : 'Вы уверены, что хотите активировать внутребанк?';
      this.$confirm(confirmTitle).then(async () => {
        const request = await this.enableInterBank(bank);
        const successMessage = mode === 'edit' ? 'Внутребанк успешно изменен' : 'Внутребанк успешно активирован';
        const errorMessage = mode === 'edit' ? 'Ошибка изменения внутребанка' : 'Ошибка активации внутребанка';
        const successMethod = mode === 'edit' ? this.resetEditBank : this.resetBankActivate;
        await this.handleRequestAndNotify({
          request,
          successMessage,
          errorMessage,
          successMethod: async () => { successMethod(); await this.loadInterBanks(); await this.loadQrInterBanks(); },
        })
      }).catch(() => {
        this.$message.info('Изменение отменено');
      });
    },
    async startDisableInterBank(id, name, interbank_type = 'sbp') {
      this.$confirm(`Вы уверены, что хотите деактивировать внутребанк по ${name}`, 'Деактивация внутребанка').then(async () => {
        const request = await this.disableInterBank({ id, interbank_type });
        await this.handleRequestAndNotify({
          request,
          successMessage: 'Внутребанк успешно деактивирован',
          errorMessage: 'Ошибка деактивации внутребанка',
          successMethod: interbank_type === 'sbp' ? this.loadInterBanks : this.loadQrInterBanks,
        })
      }).catch(() => {
        this.$message.info('Деактивация отменена');
      });
    },
    async startEditTrafficSpillAmount() {
      this.$confirm(`Вы уверены, что изменить сумму пролива`, 'Изменение суммы').then(async () => {
        const request = await this.editTrafficSpillAmount(this.editedTrafficSpill);
        await this.handleRequestAndNotify({
          request,
          successMessage: 'Сумма пролива изменена',
          errorMessage: 'Ошибка изменения суммы пролива',
          successMethod: async () => { this.resetEditTrafficSpill(); await this.loadInterBanks(); await this.loadQrInterBanks(); },
        })
      }).catch(() => {
        this.$message.info('Изменение суммы пролива отменено');
      });
    },
    async startEditRatePercent() {
      this.$confirm(`Вы уверены, что изменить процент обработки`, 'Изменение суммы').then(async () => {
        const request = await this.editInterbankRatePercent(this.editedRatePercent);
        await this.handleRequestAndNotify({
          request,
          successMessage: 'Процент обработки изменен',
          errorMessage: 'Ошибка изменения процента обработки',
          successMethod: async () => { this.resetEditRatePercent(); await this.loadInterBanks(); await this.loadQrInterBanks(); },
        })
      }).catch(() => {
        this.$message.info('Изменение процента обработки отменено');
      });
    },
    async startEnableTrafficSpill(id, interbank_type = 'sbp') {
      this.$confirm(`Вы уверены, что хотите включить пролив`, 'Включение пролива').then(async () => {
        const request = await this.enableTrafficSpill({ id, interbank_type });
        await this.handleRequestAndNotify({
          request,
          successMessage: 'Пролив включен',
          errorMessage: 'Ошибка включения пролива',
          successMethod: interbank_type === 'sbp' ? this.loadInterBanks : this.loadQrInterBanks,
        })
      }).catch(() => {
        this.$message.info('Включение пролива отменено');
      });
    },
    async startDisableTrafficSpill(id, interbank_type = 'sbp') {
      this.$confirm(`Вы уверены, что хотите отключить пролив`, 'Отключение пролива').then(async () => {
        const request = await this.disableTrafficSpill({ id, interbank_type });
        await this.handleRequestAndNotify({
          request,
          successMessage: 'Пролив отключен',
          errorMessage: 'Ошибка отключения пролива',
          successMethod: interbank_type === 'sbp' ? this.loadInterBanks : this.loadQrInterBanks,
        })
      }).catch(() => {
        this.$message.info('Отключение пролива отменено');
      });
    },
  }
};
</script>
<style scoped>
.banks__container {
  background-color: white;
  padding: 4px;
  border-radius: 4px;
}

.banks-container__title {
  text-align: center;
  font-weight: bold;
  margin: 5px auto;
}

.banks__list {
    display: flex;
    flex-wrap: wrap;
}

.bank__container {
    padding: 4px;
    margin: 2px;
    background-color: #efefef;
    width: 200px;
    height: fit-content;
    text-align: center;
    font-size: 12px;
    border: 1px solid #d1cece;
}

.bank__container .amount {
    display: flex;
    align-items: center;
}

.bank__container .amount .amount__title{
    font-weight: 500;
    margin-right: 5px;
}

.bank__container .amount__edit {
    display: flex;
    align-items: center;
}
</style>
